import { AppsflyerEvent } from '@ionic-native/appsflyer';
import { ITrackEventAction } from '@bridebook/web/lib/track-utils/actions';
import { budgetMapper } from '@bridebook/web/lib/track-utils/mappers/calculate-budget-mapper';
import { commonMapper } from '@bridebook/web/lib/track-utils/mappers/common-mapper';
import { initializedChecklistMapper } from '@bridebook/web/lib/track-utils/mappers/initialized-checklist-mapper';
import { searchResultsLoadedMapper } from '@bridebook/web/lib/track-utils/mappers/search-results-loaded-mapper';
import { sendEnquiryMapper } from '@bridebook/web/lib/track-utils/mappers/send-enquiry-mapper';
import { shortlistedSupplierMapper } from '@bridebook/web/lib/track-utils/mappers/shortlisted-supplier-mapper';
import { signedUpMapper } from '@bridebook/web/lib/track-utils/mappers/signed-up-mapper';
import { triggeredEnquiryFormMapper } from '@bridebook/web/lib/track-utils/mappers/triggered-enquiry-form-mapper';
import { updateMainTaskMapper } from '@bridebook/web/lib/track-utils/mappers/update-main-task-mapper';
import { viewedSupplierProfileMapper } from '@bridebook/web/lib/track-utils/mappers/viewed-supplier-profile-mapper';
import { TrackingEvent } from '@bridebook/web/lib/track-utils/tracking-event';
import { IApplicationState } from '@bridebook/web/lib/types';

export type ITrackingMapper<P = unknown> = (
  action: ITrackEventAction<P>,
  state: IApplicationState,
) => [string, AppsflyerEvent];

/**
 * A list of mappers following ITrackingMapper interface, that maps an event with its payload
 * to a format required by Appsflyer events:
 * https://support.appsflyer.com/hc/en-us/articles/115005544169-AppsFlyer-Rich-In-App-Events-Android-and-iOS#event-types
 */
export const trackingMappers: Record<TrackingEvent, ITrackingMapper<any>> = {
  [TrackingEvent.SignedUp]: signedUpMapper,
  [TrackingEvent.CompletedOnboarding]: commonMapper,
  [TrackingEvent.LoadedSearchResults]: searchResultsLoadedMapper,
  [TrackingEvent.ViewedSupplierProfile]: viewedSupplierProfileMapper,
  [TrackingEvent.ShortlistedSupplier]: shortlistedSupplierMapper,
  [TrackingEvent.InitializedChecklist]: initializedChecklistMapper,
  [TrackingEvent.UpdatedBudget]: budgetMapper,
  [TrackingEvent.CalculatedBudget]: budgetMapper,
  [TrackingEvent.AddedGuest]: commonMapper,
  [TrackingEvent.AddedMultipleGuests]: commonMapper,
  [TrackingEvent.UpdatedMainTasks]: updateMainTaskMapper,
  [TrackingEvent.UpdatedSubtasks]: commonMapper,
  [TrackingEvent.InitializedGuestList]: commonMapper,
  [TrackingEvent.TriggeredEnquiryForm]: triggeredEnquiryFormMapper,
  [TrackingEvent.SendEnquiry]: sendEnquiryMapper,
  [TrackingEvent.UpdatedBudgetItem]: budgetMapper,
};
